/**
 * @fileoverview Entity Picker entity list presentation component
 */

import {EntityModel, EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import {getEntityIcon} from '/ui/components/entitypicker/itemlist/entityicon';
import {EntityItem} from '/ui/components/entitypicker/itemlist/entityitem';
import {EntitySection} from '/ui/components/entitypicker/itemlist/entitysection';
import {yext} from '/ui/lib/msg';

/**
 * @typedef {{
 *   types: !Array<!EntityTypeModel>,
 *   matchedEntityTypes: (!Set<number>|undefined),
 *   locationsOnly: boolean,
 *   initialCollapsed: boolean,
 *   showMoreHandler: (function(string): void),
 *   canSelectTypes: boolean,
 *   entityTypeClickHandler: (function(EntityTypeModel): void),
 *   entityClickHandler: (function(EntityModel, EntityTypeModel): void),
 * }}
 */
export let EntityListProps;

/**
 * @param {EntityListProps} props
 * @returns {React.ReactElement}
 */
export function EntityList(props) {
  const noResultsMsg = props.locationsOnly
    ? yext.msg('There were no locations found')
    : yext.msg('There were no entities found');
  const entitySections = [];
  const initialCollapsed = props.types.length > 1
    ? props.initialCollapsed
    : false;

  for (const type of props.types) {
    const entityIcon = getEntityIcon(type);
    const typeMatchedBySearch = !!props.matchedEntityTypes && props.matchedEntityTypes.has(type.id);

    entitySections.push(
      <EntitySection
        key={type.id}
        type={type}
        icon={entityIcon}
        initialCollapsed={initialCollapsed}
        showHeader={props.types.length > 1 || typeMatchedBySearch}
        selectAllHandler={props.canSelectTypes
            ? () => props.entityTypeClickHandler(type)
            : undefined}
      >
        {type.entities.map(e =>
          <EntityItem
            key={e.id}
            entity={e}
            icon={entityIcon}
            onClick={() => props.entityClickHandler(e, type)} />)}
        {type.nextPageQuery
            && <button
              type="button"
              className="uep-show-more btn-link"
              onClick={() => props.showMoreHandler(type.nextPageQuery || '')}
            >
              {yext.msg('Show More')}
            </button>
        }
      </EntitySection>,
    );
  }

  return (
    <React.Fragment>
      {entitySections.length > 0
          ? entitySections
          : <span className="uep-no-results">{noResultsMsg}</span>}
    </React.Fragment>
  );
}
